import { readonly, ref, watch } from 'vue';
import { createSharedComposable } from '@vueuse/core';

const STORAGE_KEY = 'drafting:showTermNumber';

export const useTermNumberToggle = createSharedComposable(() => {
    // 默认值从 localStorage 读取，若无则为 false
    const _showTermNumber = ref<boolean>(localStorage.getItem(STORAGE_KEY) === 'true');

    watch(_showTermNumber, (val) => {
        localStorage.setItem(STORAGE_KEY, String(val));
    });

    function toggleTermNumber(val: boolean) {
        _showTermNumber.value = val;
    }

    return {
        showTermNumber: readonly(_showTermNumber),
        toggleTermNumber,
    };
});
